<section class="datatable datatable--flat tags-tab">
    <header class="datatable__header tags-tab__header">
        <div class="datatable-toolbar tags-tab__toolbar">
            <div class="datatable-toolbar-start tags-tab__toolbar-start"></div>

            <div class="datatable-toolbar-end tags-tab__actions">
                <div class="datatable__pagination-group pagination-rounded tags-tab__header-pagination-group">
                    <div class="datatable__pagination tags-tab__pagination">
                        <ngb-pagination [maxSize]="1" [rotate]="true" [ellipses]="true"
                            [collectionSize]="tagsData.length" [page]="pageNumber" [boundaryLinks]="true"
                            (pageChange)="onPageChange($event)" [pageSize]="pageSize">
                        </ngb-pagination>
                    </div>
                </div>

                <button class="blue-button tags-tab__add-button" type="button" (click)="onOpenTag()">
                    {{ 'ADD_TAG' | translate }}
                </button>
            </div>
        </div>
    </header>

    <div class="datatable__body tags-tab__body">
        <table class="datatable__table tags-tab__table">
            <thead>
                <tr>
                    <th class="tags-tab__col tags-tab__col--name">{{ 'NAME' | translate }}</th>
                    <th class="tags-tab__col">{{ 'DESCRIPTION' | translate }}</th>
                    <th class="tags-tab__col">{{ 'CATEGORIES' | translate }}</th>
                    <th class="tags-tab__col tags-tab__col--actions">{{ 'ACTIONS' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="tagsData.length==0">
                    <td class="tags-tab__empty" colspan="4">
                        {{ 'NO_DATA_FOUND' | translate }}
                    </td>
                </tr>
                <tr *ngFor="let tag of tempTagsData; let i=index">
                    <td class="color-anchor tags-tab__name-cell">
                        {{tag.name}}
                    </td>
                    <td class="tags-tab__text-cell">
                        {{tag.description}}
                    </td>
                    <td class="tags-tab__text-cell">
                        {{tag.categories}}
                    </td>
                    <td class="tags-tab__actions-cell">
                        <a *ngIf="iCanWrite" class="a-btn tags-tab__action-link" [routerLink]=""
                            (click)="onDeleteTag(tag.id);$event.stopPropagation();">
                            <i-feather name="x"></i-feather>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <footer class="datatable__footer tags-tab__footer">
        <div class="datatable__pagination-group tags-tab__pagination-group">
            <div class="datatable__pagination pagination-rounded tags-tab__pagination">
                <ngb-pagination [maxSize]="1" [rotate]="true" [ellipses]="true"
                    [collectionSize]="tagsData.length" [page]="pageNumber" [boundaryLinks]="true"
                    (pageChange)="onPageChange($event)" [pageSize]="pageSize">
                </ngb-pagination>
            </div>
        </div>
    </footer>
</section>